module.exports = __webpack_public_path__ + "img/station.b87fe9bb.svg";